/**
 * This class provides access to Google
 */
export class Google {
    /**
     * Constructs a new Google connection with the provided access token
     * @param token The Google Maps API key to use with all network requests
     * @param options
     */
    constructor(token, options) {
        this.token = token;
    }
}
